import Modal from 'react-modal';
import { GlobalService } from 'services/global.service';

interface BaseModalProps {
  id?: string;
  title: string;
  isOpen: boolean;
  children?: JSX.Element;
  hasCross?: boolean;
  icon?: JSX.Element;
  iconColor?: string;
  shadePourcent?: number;
  onClose: () => void;
}

const customStyles: Modal.Styles = {
  overlay: {
    zIndex: '20',
    backgroundColor: '#FFFFFF85',
  },
  content: {
    height: 'fit-content',
    width: 'fit-content',
    top: '48%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    overflow: 'auto',
    marginLeft: '32px',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderRadius: '9px',
    boxShadow: '0px 0px 30px #CCCCCC',
  },
};

Modal.setAppElement( '#root' );

export function BaseModal( {
  id,
  title,
  isOpen,
  children,
  onClose,
  icon,
  iconColor,
  hasCross = true,
  shadePourcent = 100,
}: BaseModalProps ) {
  return (
    <Modal
      id={ id }
      isOpen={ isOpen }
      shouldCloseOnOverlayClick={ false }
      shouldCloseOnEsc={ true }
      onRequestClose={ onClose }
      onAfterOpen={ () => {
        document.body.style.overflow = 'hidden';
      } }
      onAfterClose={ () => {
        document.body.style.overflow = 'unset';
      } }
      style={ customStyles }
    >
      <div className="flex flex-col min-w-[500px] max-w-[700px] max-h-[80vh] m-3 w-fit h-fit overflow-auto">
        <div className="flex h-fit min-h-8 items-center justify-left">
          {icon && iconColor ? (
            <div
              className="p-0.5 rounded-full"
              style={{
                backgroundColor: GlobalService.shadeColor(
                  iconColor,
                  shadePourcent
                ),
                fill: iconColor,
              }}
            >
              {icon}
            </div>
          ) : null}

          <span className="w-full text-xl text-left font-semibold mx-4">
            {title}
          </span>

          {hasCross ? (
            <svg
              className="w-8 h-8 cursor-pointer rounded-full hover:bg-gray-200 m-1 p-1"
              onClick={onClose}
              viewBox="0 0 94.926 94.926"
            >
              <path d="M55.931,47.463L94.306,9.09c0.826-0.827,0.826-2.167,0-2.994L88.833,0.62C88.436,0.224,87.896,0,87.335,0c-0.562,0-1.101,0.224-1.498,0.62L47.463,38.994L9.089,0.62c-0.795-0.795-2.202-0.794-2.995,0L0.622,6.096c-0.827,0.827-0.827,2.167,0,2.994l38.374,38.373L0.622,85.836c-0.827,0.827-0.827,2.167,0,2.994l5.473,5.476c0.397,0.396,0.936,0.62,1.498,0.62s1.1-0.224,1.497-0.62l38.374-38.374l38.374,38.374c0.397,0.396,0.937,0.62,1.498,0.62s1.101-0.224,1.498-0.62l5.473-5.476c0.826-0.827,0.826-2.167,0-2.994L55.931,47.463z" />
            </svg>
          ) : null}
        </div>

        <div className="flex flex-col mx-2">
          {children}
        </div>
      </div>
    </Modal>
  );
}